export default __webpack_public_path__ + "static/2040-scheda-tecnica-9c57df87c6d5101058a673f4b17b0ec2.pdf";